/**
 * TableSkeleton — animated loading placeholder for table bodies.
 * Render inside <tbody> while data loads.
 *
 *   {loading ? <TableSkeleton rows={5} cols={6} /> : items.map(...)}
 */
export default function TableSkeleton({ rows = 5, cols = 6 }) {
  return (
    <>
      {[...Array(rows)].map((_, ri) => (
        <tr key={ri} data-testid={`skeleton-row-${ri}`} className="animate-pulse">
          {[...Array(cols)].map((__, ci) => (
            <td key={ci} className="px-4 py-3">
              <div className="h-3 bg-slate-200 rounded" style={{ width: `${50 + ((ri * 7 + ci * 11) % 40)}%` }} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
